import { BankNames } from '@/constants';
import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';
import type { OfferResponseFromApi } from '@/types/offers';

import type { TBankOffers } from '../../../types/bank-offer.types';
import type { IBaseBankOffer } from '../../../types/base-offer.types';
import type { IHalykResponseApprovedBody } from '../../../types/halyk.types';

export const mapHalykBankOfferFromApi = (
  baseBankOffer: IBaseBankOffer,
  response: OfferResponseFromApi
): TBankOffers => {
  const offer = { ...baseBankOffer };

  const parsedResponseApprovedBody: IHalykResponseApprovedBody | null =
    response?.response_approved_body &&
    checkIsValidJSON(response.response_approved_body)
      ? JSON.parse(response.response_approved_body)
      : null;
  const additionalItem = parsedResponseApprovedBody?.additional?.[0];

  const loanAmount = additionalItem?.loan_amount || response?.loan_amount || '';
  const initialPayment = additionalItem?.down_payment
    ? Number(response?.vehicle_cost || 0) - Number(additionalItem.down_payment)
    : Number(response?.initial_payment || 0);
  const monthlyPayment =
    additionalItem?.monthly_payment || response?.monthly_payment || '';
  const rate = additionalItem?.interest_rate || response?.rate || '';

  return {
    ...offer,
    bankName: BankNames.halyk,
    loanAmount,
    initialPayment: String(initialPayment),
    monthlyPayment,
    rate: String(rate)
  };
};
